export default "__VITE_ASSET__DyfKe2a7__"